import { Edit } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'
import WindowDialog from 'components/dialog/WindowDialog'
import DialogReuniaoForm from 'entity/Reuniao/components/ReuniaoForm/DialogReuniaoForm'
import React, { useState } from 'react'

export default function ButtomEditNewReuniao({ rodada, inscritos, initialValues, overSaveReuniao, ...props }) {
    const [open, setOpen] = useState(false)
    
    return (
        <div>

            <IconButton onClick={() => setOpen(true)}><Edit /></IconButton>
            {open &&
                <WindowDialog
                    title={rodada ? "Nova Reunião - " + rodada.nome : "Nova Reunião"}
                    onClose={() => {
                        setOpen(false)
                    }}
                    open={open}
                    titleButtons={
                        <Box sx={{ display: "flex", gap: 1 }}>
                            {/* <Button
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    console.log("form", form)
                                    // console.log("form.formProps.form", form.formProps.form)
                                    
                                    // form.formProps.form.restart(ReuniaoEntity.initialize)

                                    setNewValues()
                                    form.reset()
                                }}
                            >
                                Nova
                            </Button> */}
                            {/* <SubmitButton
                                size="small"
                                startIcon={<CheckIcon />}
                                onClick={() => {
                                    // console.log("salvar")
                                    // console.log("form", form)
                                    form.submit()
                                }}
                            />
                            <Button size="small" startIcon={<CloseIcon />} onClick={() => setOpen(false)}>
                                Cancelar
                            </Button> */}
                        </Box>
                    }

                >
                    {() => {
                        return (
                            <DialogReuniaoForm setOpen={setOpen} rodada={rodada} inscritos={inscritos} initialValues={initialValues} overSave={overSaveReuniao} {...props} />
                        )
                    }}
                </WindowDialog>
            }
        </div>
    )
}